import isObject from './isObject'

function isRegExp(reg : unknown) : reg is RegExp{
    return Object.prototype.toString.call(reg) === '[object RegExp]'
}

function isDate(reg : unknown) : reg is Date{
    return Object.prototype.toString.call(reg) === '[object Date]'
}

/**
 * 
 * @param obj 将obj处理为规范的参数字符串
 */
export default function serialize(obj : any) : string | symbol{
	let type = typeof obj

	if(obj == null){
		return ''
    }else if(type === 'symbol'){
        return obj
    }else if(type === 'string' || type === 'number' || type === 'boolean' || isRegExp(obj)){
        return obj+''
    }else if(type === 'bigint'){
        return obj + 'n'
    }else if(isDate(obj)){
        return obj.valueOf() + ''
    }else if(Array.isArray(obj)){
		const items = obj.map((item)=> serialize(item) )
		return `[${items.join(',')}]`
	}else if(isObject(obj)) {
		const keys = Object.keys(obj)
		keys.sort()
		const items = keys.map((key)=> `${key}=${serialize(obj[key]) as string}`)
		return `{${items.join('&')}}`
	}else if(typeof obj.valueOf === 'function'){
		return serialize(obj.valueOf())
	}else{
		return obj+''
	}
}